import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import { ArchiveClusterArchives } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
export const ARCHIVE_INDICES_SUMMARY_QUERY_KEY = "archiveIndicesSummary";
const fetchIndicesSummary = async () => ArchiveClusterArchives.indicesSummary();
const useArchiveIndicesSummary = () => useQuery({
  queryKey: [ARCHIVE_INDICES_SUMMARY_QUERY_KEY],
  queryFn: () => defaultOnError(
    fetchIndicesSummary(),
    i18n.t("notifications.fetch_indices_summary_failed", { ns: "enterprise_archive" })
  ),
  retry: 0
});
export default useArchiveIndicesSummary;
